import { Injectable } from '@angular/core';
import { ChatsService } from 'common/chats/chats.service';
import { Chat } from 'common/xislivechat/models/chat';
import { DynamicQueryStoreObservableFactory } from 'common/dynamicquery/dynamic-query-store-observable';

@Injectable()
export class ChatsStoreFactoryService {
  constructor(private chatsService: ChatsService,
              private dynamicQueryStoreObservableFactory: DynamicQueryStoreObservableFactory) {
  }

  /**
   * Creates an Array Store Observable but for only one chat.
   * @param {String} chatId
   * @throws Error 'Missing chatId'
   * @returns {Observable<Array<Chat>>}
   */
  createForSingleChat(chatId) {
    const activeChats = this.chatsService.observeChatByChatId(chatId);
    // TODO: It can be replaceable by an ObjectStoreObservable
    return this.dynamicQueryStoreObservableFactory.create(activeChats, Chat.comparator);
  }
}
